import { Helmet } from 'react-helmet-async';
import PageHeader from '@/content/Management/Users/settings/PageHeader';
import PageTitleWrapper from '@/components/PageTitleWrapper';
import { Container, Grid } from '@mui/material';

// import NotificationsTab from '@/content/Management/Users/settings/NotificationsTab';
import SecurityTab from '@/content/Management/Users/settings/SecurityTab';

// const TabsWrapper = styled(Tabs)(
//   () => `
//     .MuiTabs-scrollableX {
//       overflow-x: auto !important;
//     }
// `
// );

function ManagementUserSettings() {
  return (
    <>
      <Helmet>
        <title>User Settings - Applications</title>
      </Helmet>
      <PageTitleWrapper>
        <PageHeader />
      </PageTitleWrapper>
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            {/* {currentTab === 'notifications' && <NotificationsTab />} */}
            <SecurityTab />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default ManagementUserSettings;
